import { render, staticRenderFns } from "./TermSignatureForm.vue?vue&type=template&id=973b498a&scoped=true"
import script from "./TermSignatureForm.vue?vue&type=script&lang=js"
export * from "./TermSignatureForm.vue?vue&type=script&lang=js"
import style0 from "./TermSignatureForm.vue?vue&type=style&index=0&id=973b498a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973b498a",
  null
  
)

export default component.exports